import configHandler from '../configHandler'

const CURRENCY = 'currency'
const CURRENCY_FORMAT = 'currency-format'

const parse = (inputAmount) => {

    return {
        inputAmount: inputAmount,
        amount: parseFloat(inputAmount),
        errors: [],

        format: function (decimals, withCurrency) {
            decimals = decimals !== undefined ? decimals : 2
            withCurrency = withCurrency !== undefined ? withCurrency : false

            const formatter = new Intl.NumberFormat(configHandler.getNumberRegion(), {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            })
            const formattedAmount = formatter.format(this.amount)
            if (!withCurrency) {
                return formattedAmount
            }
            const currency = configHandler.getMoneyFormat(CURRENCY)
            const currencyFormat = configHandler.getMoneyFormat(CURRENCY_FORMAT)
            return currencyFormat.replace('{amount}', formattedAmount).replace('{currency}', currency)
        },

        isValid: function () {
            return this.validate().length === 0
        },
        validate: function () {
            this.errors = []

            if (isNaN(this.amount)) {
                this.errors.push(configHandler.errorMessages().money.invalidAmount)
            }

            return this.errors
        },

        input: function () {
            return this.inputAmount
        },
    }
}

export default {
    parse,
}